import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import api from "../../lib/api";
import { SectionHead } from "./ShortsRail";

const INSTAGRAM_HREF = "https://www.instagram.com/garagedrops";
const srcOf = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

// Cookie-free: covers are copied on our server, cards just link to Instagram.
export const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/instagram/latest", { params: { limit: 6 } })
      .then((r) => setPosts(r.data?.posts || []))
      .catch(() => setPosts([]));
  }, []);

  if (!posts.length) return null;

  return (
    <section className="py-14 sm:py-20" style={{ background: "#FFFFFF", borderTop: "1px solid rgba(0,0,0,0.06)" }} data-testid="home-instagram">
      <SectionHead kicker="Instagram · @garagedrops" title="Gli ultimi post." href={INSTAGRAM_HREF} cta="Seguici" testid="home-instagram-follow" dark={false} />
      <div className="max-w-[1320px] mx-auto px-4 sm:px-8 grid grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4">
        {posts.map((p, i) => <PostCard key={p.id} p={p} i={i} />)}
      </div>
    </section>
  );
};

function PostCard({ p, i }) {
  const href = p.permalink || p.url;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noreferrer"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: i * 0.05 }}
      className="group relative block overflow-hidden"
      style={{ aspectRatio: "1/1", background: "#F2EFE9" }}
      data-testid={`home-ig-post-${i}`}
    >
      {p.image ? (
        <img src={srcOf(p.image)} alt={(p.caption || "Post Instagram").slice(0, 100)} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      ) : (
        <span className="absolute inset-0 flex flex-col items-center justify-center gap-3" style={{ color: "#111" }}>
          <Instagram size={34} strokeWidth={1.3} color="#bc1888" />
          <span className="text-[13px] underline">Apri su Instagram</span>
        </span>
      )}
      <span className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center" style={{ background: "rgba(255,255,255,0.9)" }}>
        <Instagram size={16} strokeWidth={1.6} color="#111" />
      </span>
      {p.caption ? (
        <span className="absolute inset-0 p-4 flex items-end opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0) 30%, rgba(0,0,0,0.75) 100%)" }}>
          <span className="text-[13px] line-clamp-4" style={{ color: "#FFF", lineHeight: 1.4 }}>{p.caption}</span>
        </span>
      ) : null}
    </motion.a>
  );
}
